import PropTypes from "prop-types";
import { Box, Tooltip } from "@mui/material";

import { DocumentationLink } from "./DocumentationLink";

/**
 * Renderiza la lista de enlaces de documentación de una tarea como chips
 * compactos, con separación real y wrap controlado.
 *
 * Sustituye al patrón de mapear varios <DocumentationLink> sueltos, que se
 * concatenaban sin separador en las tarjetas del Kanban.
 */
export const DocumentationLinkList = ({ urls, variant = "chip", sx = {} }) => {
  const cleanUrls = (urls || []).filter(
    (url) => typeof url === "string" && url.trim()
  );

  if (cleanUrls.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0.75,
        minWidth: 0,
        ...sx,
      }}
    >
      {cleanUrls.map((url, index) => (
        <Tooltip key={`${index}-${url}`} title={url} placement="top" arrow>
          <Box component="span" sx={{ display: "inline-flex", minWidth: 0 }}>
            <DocumentationLink url={url} variant={variant} />
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

DocumentationLinkList.propTypes = {
  urls: PropTypes.arrayOf(PropTypes.string),
  variant: PropTypes.oneOf(["text", "chip"]),
  sx: PropTypes.object,
};
